import { css } from "lit";

export const styles = css`
  :host {
    --spinner-color: #222225;
    --spinner-size: var(--size-3);
    --part-height: 8px;
    --part-width: 4px;
    --part-offset: 10px;

    display: inline-block;
  }

  .spinner {
    position: relative;
    width: var(--spinner-size);
    height: var(--spinner-size);
  }

  [data-invert] {
    --spinner-color: var(--color-white);
  }

  [data-size="xs"] {
    --spinner-size: var(--size-2);
    --part-height: 5px;
    --part-width: 2.5px;
    --part-offset: 6.5px;
  }

  [data-size="sm"] {
    --spinner-size: var(--size-2-5);
    --part-height: 6.5px;
    --part-width: 3.5px;
    --part-offset: 8.5px;
  }

  [data-size="lg"] {
    --spinner-size: var(--size-5);
    --part-height: 13.25px;
    --part-width: 5.25px;
    --part-offset: 17.5px;
  }

  .spinner > div {
    position: absolute;
    top: var(--part-height);
    left: var(--part-offset);
    width: var(--part-width);
    height: var(--part-height);
    background-color: var(--spinner-color);
    border-radius: var(--part-width);
    animation: spinner-part 1s linear infinite;
    will-change: opacity;
  }

  .spinner > div:nth-child(1) {
    transform: rotate(45deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1.625s;
  }

  .spinner > div:nth-child(2) {
    transform: rotate(90deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1.5s;
  }

  .spinner > div:nth-child(3) {
    transform: rotate(135deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1.375s;
  }

  .spinner > div:nth-child(4) {
    transform: rotate(180deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1.25s;
  }

  .spinner > div:nth-child(5) {
    transform: rotate(225deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1.125s;
  }

  .spinner > div:nth-child(6) {
    transform: rotate(270deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -1s;
  }

  .spinner > div:nth-child(7) {
    transform: rotate(315deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -0.875s;
  }

  .spinner > div:nth-child(8) {
    transform: rotate(360deg) translateY(calc(-1 * var(--part-height)));
    animation-delay: -0.75s;
  }

  @keyframes spinner-part {
    0% {
      opacity: 0.85;
    }
    50% {
      opacity: 0.25;
    }
    100% {
      opacity: 0.25;
    }
  }
`;
